module.exports = __webpack_public_path__ + "img/labour2.b005b12b.svg";